var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineColorsSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.25 14.4c0-1.96 1.32-3.69 3.21-4.2.37-.1.75.09.89.45.33.83 1.04 1.47 1.9 1.7.47.13 1.03.13 1.5 0 .37-.1.76.09.9.44a4.37 4.37 0 0 1-1.15 4.84c-.79.72-1.82 1.12-2.9 1.12-2.4 0-4.35-1.95-4.35-4.35zm1.5 0c0 1.57 1.28 2.85 2.85 2.85.7 0 1.38-.26 1.9-.73a2.822 2.822 0 0 0 .91-2.59c-.53.05-1.07 0-1.56-.14a4.356 4.356 0 0 1-2.56-1.92 2.85 2.85 0 0 0-1.54 2.53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.85 13.8a4.373 4.373 0 0 1-2.89-2.59c-.2-.51-.3-1.05-.3-1.6 0-2.4 1.95-4.35 4.35-4.35 2.4 0 4.35 1.95 4.35 4.35 0 .55-.1 1.09-.3 1.6A4.341 4.341 0 0 1 12 13.95c-.4 0-.79-.05-1.15-.15zm-1.7-4.2a2.857 2.857 0 0 0 2.1 2.75c.47.13 1.03.13 1.5 0 .87-.24 1.58-.87 1.9-1.7A2.855 2.855 0 0 0 12 6.75c-1.57 0-2.85 1.28-2.85 2.85z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 17.63a.75.75 0 0 1 0-1.12 2.82 2.82 0 0 0 .75-3.16.762.762 0 0 1 .5-1 2.88 2.88 0 0 0 1.9-1.7.75.75 0 0 1 .89-.45c1.89.51 3.21 2.24 3.21 4.2 0 2.4-1.95 4.35-4.35 4.35-1.08 0-2.11-.4-2.9-1.12zm2.9-.38c1.57 0 2.85-1.28 2.85-2.85 0-1.08-.61-2.05-1.54-2.53-.44.72-1.09 1.3-1.85 1.66a4.318 4.318 0 0 1-.74 3.42c.39.2.83.3 1.28.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 22.75c-5.43 0-7.75-2.32-7.75-7.75V9c0-5.43 2.32-7.75 7.75-7.75h6c5.43 0 7.75 2.32 7.75 7.75v6c0 5.43-2.32 7.75-7.75 7.75H9zM2.75 9v6c0 4.61 1.64 6.25 6.25 6.25h6c4.61 0 6.25-1.64 6.25-6.25V9c0-4.61-1.64-6.25-6.25-6.25H9C4.39 2.75 2.75 4.39 2.75 9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineColorsSquare);
export default __webpack_public_path__ + "static/media/vuesax-outline-colors-square.04708154c0a1fb9585c60ffee8b0d535.svg";
export { ForwardRef as ReactComponent };